import { render, staticRenderFns } from "./PlanDetailsCardTable.vue?vue&type=template&id=50bf74b2&lang=pug"
import script from "./PlanDetailsCardTable.vue?vue&type=script&lang=js"
export * from "./PlanDetailsCardTable.vue?vue&type=script&lang=js"
import style0 from "./PlanDetailsCardTable.vue?vue&type=style&index=0&id=50bf74b2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports